// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1Gzpk","content":"Consent_content__2t7sI","footer":"Consent_footer__2h5de"};